import { useUserProfileQuery } from "@graphql/api";
import ConcentricLoader from "@hudson/ui/components/Loader/ConcentricLoader";
import Success from "@hudson/ui/components/Success";
import Session from "@lib/session";
import useConfig from "@lib/use_config";
import useContent from "@lib/use_content";
import { useState } from "react";
import AttachedAccount from "./AttachedAccount";
import Form from "./Form";

export default function LinkedGroup({}) {
  const [showForm, setShowForm] = useState(false);
  const [success, setSuccess] = useState(false);
  const {
    data,
    loading: contentLoading,
    error,
  } = useContent(["beProfileLinkedGroupsTitle", "beProfileLinkedGroupsSuccessMsg"]);
  const { loading: cfgLoading, data: cfgData } = useConfig(["linkedGroupFields"]);

  const { data: profileData } = useUserProfileQuery();
  const currentLinkedGroup = profileData?.userProfile?.linkedGroupName;

  return (
    <div className="pb-8">
      <div className="mt-8 mb-4 space-y-1">
        <h3 className="text-xl font-bold leading-6 text-gray-900">
          {data?.content.beProfileLinkedGroupsTitle}
        </h3>
      </div>

      {!showForm && currentLinkedGroup ? (
        <AttachedAccount
          name={currentLinkedGroup}
          onEdit={() => {
            setSuccess(false);
            setShowForm(true);
          }}
        />
      ) : null}

      {success && (
        <Success
          className="mt-6"
          message={data?.content.beProfileLinkedGroupsSuccessMsg}
          heavyStyle
          scrollTo
        />
      )}

      {showForm || !currentLinkedGroup ? (
        cfgLoading ? (
          <ConcentricLoader className="max-w-2xl px-4 mx-auto opacity-60 sm:py-10 sm:px-6 lg:px-8" />
        ) : (
          <Form
            className="mt-6"
            fields={cfgData?.config.linkedGroupFields || []}
            onHide={(isSuccess) => {
              setSuccess(!!isSuccess);
              setShowForm(false);
            }}
            showCancel={!!currentLinkedGroup}
          ></Form>
        )
      ) : null}
    </div>
  );
}
